// material-ui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface NoMenuPermissionsPageProps {
  handleBackButton: () => void;
}

// ==============================|| NO MENU PERMISSIONS ERROR PAGE ||============================== //

const NoMenuPermissions = ({
  handleBackButton
}: NoMenuPermissionsPageProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      open={true}
      // onClose={}
      aria-labelledby='change-delivery-point-assigment-dialog-title'
      maxWidth='xs'
      fullWidth
    >
      <>
        <DialogTitle id='dialog-title'>
          {t('common.messages.noMenuPermissionsLabel')}
        </DialogTitle>
        <Divider
          sx={{
            opacity: 1,
            borderColor:
              theme.palette.mode === 'dark'
                ? theme.palette.dark.light + 15
                : theme.palette.grey[200]
          }}
        />
        <DialogContent>
          <Stack spacing={2}>
            {t('common.messages.noMenuPermissionsText')}
          </Stack>
        </DialogContent>

        <DialogActions sx={{ pr: 2.5 }}>
          <Button size='small' onClick={handleBackButton}>
            {t(`common.button.back`)}
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default NoMenuPermissions;
